<template>
  <div>
    <el-row v-if="edit_filter">
      <el-col>
        Delete Filter :
        <span title="Delete">
          <i
            class="fa fa-trash-o"
            style="color: red"
            @click="deleteFilter()"
          ></i> </span
      ></el-col>
    </el-row>
    <br />
    <el-row :gutter="30">
      <el-col :span="6">
        <label>Filter Name :</label>
        <span class="text-danger">*</span>
        <el-input v-model="externalFilterInfo.filter_name"></el-input>
      </el-col>
      <el-col
        :span="6"
        v-for="(externalFilter, index) in externalFilters"
        :key="index"
      >
        <label
          >Select Quick Filter Field for {{ externalFilter.label }} :
        </label>
        <span class="text-danger" v-if="externalFilter.isRequired">*</span>
        <el-select
          v-model="externalFilterInfo.externalQuickFilters[externalFilter.key]"
          :placeholder="placeholder"
          size="small"
          filterable
        >
          <el-option
            v-for="(field, index) in quickFilterFields"
            :key="index"
            :value="field.template_key"
            :label="`${field.label}`"
          />
        </el-select>
      </el-col>
    </el-row>
    <br />
  </div>
</template>

<script>
export default {
  props: {
    quickFilterFields: Array,
    externalFilters: Array,
    externalFilterInfo: Object,
    rules: Object,
    placeholder: String,
    edit_filter: Boolean,
  },
  methods: {
    deleteFilter() {
      this.$emit("delete-filter");
    },
  },
};
</script>
